import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetLatestObservations } from '@hooks/api/observation';
import { useBulkViewable } from '@hooks/useBulkViewable';

import { TrackerType } from '@models/vital-sign';

import HealthTrackerMain from '@views/Records/HealthTracker/Main';

const messages = defineMessages({
  title: {
    id: 'vitalSignsMain.title',
    defaultMessage: 'Vital Signs',
  },
});

const VitalSignsMain: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();
  useBulkViewable({ resource_name: 'Observation', category: 'vital-signs' });

  const {
    data: {
      heart_rate,
      hrv,
      temperature,
      blood_pressure,
      respiration,
      oxygen_saturation,
      pain,
      // stress_index,
    },
    loading,
  } = useGetLatestObservations({
    heart_rate: true,
    temperature: true,
    blood_pressure: true,
    respiration: true,
    oxygen_saturation: true,
    pain: true,
    hrv: true,
    // stress_index: true,
  });

  const records = {
    heart_rate,
    temperature,
    blood_pressure,
    respiration,
    oxygen_saturation,
    pain,
    hrv,
    // stress_index,
  };

  return (
    <HealthTrackerMain
      category={TrackerType.VitalSigns}
      loading={loading}
      records={records}
      title={formatMessage(messages.title)}
    />
  );
};

export default withErrorBoundary(VitalSignsMain, {
  FallbackComponent: ErrorBoundaryFallback,
});
